import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import '../../css/resultTable.css';
import '../../css/buttonMidTimeTable.css';
import MenuItem from "@material-ui/core/es/MenuItem/MenuItem";
import Select from "@material-ui/core/es/Select/Select";
import FormControl from "@material-ui/core/es/FormControl/FormControl";
import Transcription from "./Transcription";

const styles = theme => ({
    root: {
        width: '49%',
    },
    paper: {
        // marginTop: theme.spacing(3),
        width: '49%',
        overflowX: 'auto',
        //marginBottom: theme.spacing(2),
        marginTop: 0,
        marginBottom: 0
    },
    table: {
        minWidth: 300,
        padding: 0,
        margin: 0,
    },
    activeRow: {
        color: 'white',
        backgroundColor: 'darkGrey'
    }
});

class MidResultTable extends React.Component {

    constructor() {
        super();
        this.state = {
            pocetUseku: 2,
            pocetStartu: 1,
            vybranyPocetUseku: 0,
            midAthlets: [],
            midAthletProtocol: []
        };
    }

    handleChange = async event => {
        await this.setState({
            vybranyPocetUseku: event.target.value
        })
    };

    render() {
        const classes = styles();
        let atleti;
        switch (this.state.vybranyPocetUseku) {
            case 1:
                atleti = this.props.inProgress
                    .filter(athlete => {
                        return athlete.cas1 > 0
                    })
                    .sort((a, b) => {
                        return a.cas1 - b.cas1;
                    });
                break;
            case 2:
                atleti = this.props.inProgress.sort((a, b) => {
                    return a.cas2 - b.cas2;
                });
                break;
            case 3:
                atleti = this.props.inProgress.sort((a, b) => {
                    return a.cas3 - b.cas3;
                });
                break;
            case 4:
                atleti = this.props.inProgress.sort((a, b) => {
                    return a.cas4 - b.cas4;
                });
                break;
            default: {
                atleti = this.props.athletes;
                // console.log("no change, show result in finish");
            }
        }

        if (this.props.raceInfo.kodStc === 3) {
            if (this.props.inProgress.find(({stc}) => stc === this.props.raceInfo.stc) !== undefined) {
                let a = this.props.inProgress.find(({stc}) => stc === this.props.raceInfo.stc)
                if (a.cas1 > 0) {
                    let tmp = this.props.inProgress.filter(a => {
                        return a.cas1 > 0
                    })
                        .sort((a, b) => {
                            return a.cas1 - b.cas1
                        });
                    a.poradi = tmp.indexOf(a) + 1;
                    // console.log("poradi v poli " + this.state.midAthlets.indexOf(a))
                    if (this.state.midAthlets.indexOf(a) === -1) {
                        this.state.midAthlets.push(a);
                        console.log(this.state.midAthlets)
                        // this.setState({midAthletProtocol: this.state.midAthlets.splice(-1, 1)});
                    }
                }
            }
            // if (this.state.midAthlets.length > 2) {
            //     this.setState({midAthletProtocol: this.state.midAthlets.splice(-1, 1)});
            //     console.log(this.state.midAthletProtocol);
            // }
        }

        let protocolMid = this.state.midAthlets.slice(-2).map((athlet, key) => (
            <TableRow key={key}>
                <TableCell className={"cat"}>{isNaN(athlet.poradi) ? athlet.poradi : athlet.poradi + '.'}</TableCell>
                <TableCell className={"cat"}>{athlet.bib}</TableCell>
                <TableCell>{athlet.jmeno}</TableCell>
                <TableCell
                    className={"tj"}>{athlet.tj.localeCompare("    ") === 0 ? athlet.klub : athlet.tj}</TableCell>
                <TableCell
                    className={"time"}>{Transcription.transposeTime(athlet.cas1, this.props.raceInfo.pocDes)}</TableCell>
                <TableCell className="gap">&nbsp;</TableCell>
                <TableCell className={"cat"}>{athlet.zkrkat}</TableCell>
                {/*<td>&nbsp;</td>*/}
                {/*<td>&nbsp;</td>*/}
            </TableRow>
        ));

        let protocol = this.props.protocol.map((athlet, key) => (
            <TableRow key={key}>
                <TableCell className={"cat"}>{isNaN(athlet.poradi) ? athlet.poradi : athlet.poradi + '.'}</TableCell>
                <TableCell className={"cat"}>{athlet.bib}</TableCell>
                <TableCell>{athlet.jmeno}</TableCell>
                <TableCell
                    className={"tj"}>{athlet.tj.localeCompare("    ") === 0 ? athlet.klub : athlet.tj}</TableCell>
                <TableCell
                    className={"time"}>{Transcription.transposeTime(athlet.cas, this.props.raceInfo.pocDes)}</TableCell>
                <TableCell
                    className="gap">&nbsp;</TableCell>
                <TableCell className={"cat"}>{athlet.zkrkat}</TableCell>
                {/*<td>&nbsp;</td>*/}
                {/*<td>&nbsp;</td>*/}
            </TableRow>
        ));

        let row =
            <TableRow>
                <TableCell>&nbsp;</TableCell>
                <TableCell>&nbsp;</TableCell>
                <TableCell>&nbsp;</TableCell>
                <TableCell>&nbsp;</TableCell>
                <TableCell>&nbsp;</TableCell>
                <TableCell>&nbsp;</TableCell>
                <TableCell>&nbsp;</TableCell>
                {/*<td>&nbsp;</td>*/}
                {/*<td>&nbsp;</td>*/}
            </TableRow>;
        let oneRow = <>
            {protocol}
            {row}
        </>
        let twoRows = <>
            {protocol}
            {row}
            {row}
        </>;
        let threeRows = <>
            {row}
            {row}
            {row}
        </>;

        return (
            <div>

                <Paper>
                    <Table className={classes.table} size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan="4">
                                    <button className={"btn-mid"}
                                            onClick={() => this.setState({vybranyPocetUseku: 1})}>Mzč1
                                    </button>
                                    <button className={"btn-mid"}
                                            onClick={() => this.setState({vybranyPocetUseku: 0})}>Cíl
                                    </button>
                                </TableCell>
                                {this.props.stat !== undefined ?
                                    <TableCell colSpan="3">DNS: {this.props.stat[0]} - Na startu: {this.props.stat[1]} -
                                        Na
                                        trati: {this.props.stat[2]} - V cíli: {this.props.stat[3]} -
                                        DSQ: {this.props.stat[4]} - DNF: {this.props.stat[5]}</TableCell>
                                    : <TableCell colSpan="5">&nbsp;</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={"7"} align={"center"}>Události Mezičas</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {protocolMid}
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={"7"} align={"center"}>Události cíl</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.props.protocol.length === 0 ? threeRows : this.props.protocol.length === 1 ? twoRows :
                                this.props.protocol.length === 2 ? oneRow : protocol}
                        </TableBody>
                        <TableRow>
                            <TableCell colSpan={"7"}
                                       align={"center"}>{this.state.vybranyPocetUseku === 1 ? "Mezičas 1" : "Cíl"}</TableCell>
                        </TableRow>

                        <TableHead>
                            <TableRow>
                                <TableCell>Poř.
                                    {/*<form autoComplete={'off'}>*/}
                                    {/*    <FormControl>*/}
                                    {/*        <Select*/}
                                    {/*            value={this.state.vybranyPocetUseku}*/}
                                    {/*            onChange={this.handleChange}*/}
                                    {/*        >*/}
                                    {/*            <MenuItem value={1}>Mzč: {1}</MenuItem>*/}
                                    {/*            /!*<MenuItem value={2}>Mzč: {2}</MenuItem>*!/*/}
                                    {/*            /!*<MenuItem value={3}>Mzč: {3}</MenuItem>*!/*/}
                                    {/*            <MenuItem value={0}>Cíl</MenuItem>*/}

                                    {/*        </Select>*/}
                                    {/*    </FormControl>*/}
                                    {/*</form>*/}

                                </TableCell>
                                <TableCell>stč.</TableCell>
                                <TableCell>Jméno</TableCell>
                                <TableCell>TJ</TableCell>
                                <TableCell>Klub</TableCell>
                                <TableCell>Kat.</TableCell>
                                <TableCell>Čas</TableCell>
                            </TableRow>

                        </TableHead>
                        <TableBody>

                            {atleti.map((athlet, key) => (
                                <TableRow key={athlet.id} className={
                                    this.props.raceInfo.stc === athlet.stc ? "resultRowActive" : (key % 2 === 0) ? "resultDark" : ''
                                }>
                                    <TableCell component="th" scope="row">{key + 1}.</TableCell>
                                    <TableCell>{athlet.bib}</TableCell>
                                    <TableCell>{athlet.jmeno}</TableCell>
                                    <TableCell>{athlet.tj}</TableCell>
                                    <TableCell>{athlet.klub}</TableCell>
                                    <TableCell>{athlet.zkrkat}</TableCell>
                                    <TableCell
                                        align="right">{this.state.vybranyPocetUseku === 0 ? Transcription.transposeTime(athlet.cas, this.props.raceInfo.pocDes) : this.state.vybranyPocetUseku === 1 ? Transcription.transposeTime(athlet.cas1, this.props.raceInfo.pocDes) :
                                        this.state.vybranyPocetUseku === 2 ? Transcription.transposeTime(athlet.cas2, this.props.raceInfo.pocDes) : Transcription.transposeTime(athlet.cas3, this.props.raceInfo.pocDes)}</TableCell>

                                </TableRow>
                            ))}

                        </TableBody>
                    </Table>
                </Paper>
            </div>
        )

    }
}

export default MidResultTable;